// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ff8Y","question":"styles_question__2qzJS","inputVisibleButton":"styles_inputVisibleButton__2QC-6","note":"styles_note__1fCR2"};